<div class="confirm-dialog">

  <h3 class="title" *ngIf="data?.title" [innerHTML]="data.title"></h3>
  <p class="message" [innerHTML]="data.message"></p>

  <div class="group-actions">
    <button class="secondary__button m__r--16" [innerHTML]="data.cancelLabel" (click)="onDismiss()"></button>
    <button *ngIf="data.confirmLabel" class="primary__button" [innerHTML]="data.confirmLabel" (click)="onConfirm()"></button>
    <button *ngIf="data.dangerConfirmLabel" class="danger__button" [innerHTML]="data.dangerConfirmLabel" (click)="onConfirm()"></button>
  </div>

</div>